import { z } from 'zod';

export const BusinessStartDateProcessPayloadSchema = z.object({
    businessStartDate: z.date().optional(),
});

export class BusinessStartDateProcessPayload {
    businessStartDate?: Date;
}
